module.exports = __webpack_public_path__ + "static/media/faq-icon.8e14f31c.svg";